import { cloneDeep } from 'lodash-es';
import React from 'react';
import { Spinner } from '@apia/theme';
import { IReplacer } from './AttributeParsers';
import { importTemplaterComponent, parseShortcut } from './Templater';

export interface ICommentReplacerData {
  customShortcuts: string[][];
  SuspenseComponent: React.FunctionComponent;
}

const CommentsParsers: IReplacer<ICommentReplacerData, ICommentReplacerData>[] =
  [
    {
      /**
       * This parser allows to put a comment with the structure:
       * <!-- addRoute<newName,path/to/the/components> -->
       * And then use it in replacement of the path:
       *
       * @example
       *
       * <!-- addRoute<modals,path/to/the/modals> -->
       * <div data-component="modals/Info">...
       */
      match: /addRoute *<(.{2,}),(.+)>/,
      parse(result, commentsData) {
        const routeShourtcut = result[1];
        const routePath = result[2];
        const newData = cloneDeep(commentsData);
        newData.customShortcuts.push([
          parseShortcut(routeShourtcut),
          routePath,
        ]);
        return newData;
      },
    },
    {
      /**
       * This parser allows anybody to put a comment with the structure:
       * <!-- SuspenseComponent<path/to/Component> --> or
       * <!-- SuspenseComponent<null> -->
       * which will result in a custom for the lazy components.
       */
      match: /SuspenseComponent *<(\w+)>/,
      parse(result, commentsData) {
        const responseData = commentsData;
        if (result[1].toLowerCase() === 'spinner')
          responseData.SuspenseComponent = Spinner;
        else
          responseData.SuspenseComponent = importTemplaterComponent(result[1]);
        return responseData;
      },
    },
  ];

export default CommentsParsers;
